export type DurationUnit = 'seconds' | 'hours' | 'days';

const UNIT_TO_SECONDS: Record<DurationUnit, number> = {
  seconds: 1,
  hours: 60 * 60,
  days: 60 * 60 * 24,
};

export const convertDuration = (
  value: number | null | undefined,
  from: DurationUnit,
  to: DurationUnit,
): number | null => {
  if (value === null || value === undefined) return null;
  return (value * UNIT_TO_SECONDS[from]) / UNIT_TO_SECONDS[to];
};

export const toSeconds = (value: number | null | undefined, unit: DurationUnit): number | null =>
  convertDuration(value, unit, 'seconds');

export const fromSeconds = (value: number | null | undefined, unit: DurationUnit): number | null =>
  convertDuration(value, 'seconds', unit);
